import React from 'react';
import { connect } from 'react-redux';

import { CodeSnippet, CodeSnippetBackgroundStyle, CodeSnippetProps } from 'UI-Dash-Commons-UI';
import { STATE_DSP_DOCS } from '../redux/constants';
import { onToggleCodeSnippetBackgroundStyle } from '../redux/actions';

const mapStateToProps = state =>
    ( {
        codeSnippetBackgroundStyle: state[ STATE_DSP_DOCS ].codeSnippetBackgroundStyle
    } );

const mapDispatchToProps = dispatch =>
    ( {
        toggleCodeSnippetBackgroundStyle: (codeSnippetBackgroundStyle: CodeSnippetBackgroundStyle) => dispatch( onToggleCodeSnippetBackgroundStyle(codeSnippetBackgroundStyle === CodeSnippetBackgroundStyle.LIGHT ? CodeSnippetBackgroundStyle.DARK : CodeSnippetBackgroundStyle.LIGHT)  ),
    } );

const MediationCodeSnippetContainer = (props: CodeSnippetProps) => <CodeSnippet {...props}/>;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( MediationCodeSnippetContainer );
